import { useOktaAuth } from '@okta/okta-react';
import { TdsLoadingSpinner } from '@trv-tds/react';
import { toRelativeUrl } from '@okta/okta-auth-js';
import { Outlet } from 'react-router';
import { useEffect, useState, useRef } from 'react';

export const SecureRoute = () => {
  const { oktaAuth, authState } = useOktaAuth();
  const [isValidating, setIsValidating] = useState(false);
  const hasValidated = useRef(false);

  useEffect(() => {
    const validateSession = async () => {
      if (!authState) {
        return;
      }

      // If authenticated and haven't validated yet, verify the session is still valid
      if (authState?.isAuthenticated && !hasValidated.current) {
        setIsValidating(true);
        hasValidated.current = true;
        
        try {
          // Try to renew token to verify session is still active on Okta server
          await oktaAuth.tokenManager.renew('accessToken');
        } catch (error) {
          // Session is invalid (e.g., logged out elsewhere), clear tokens
          console.log('Session validation failed, clearing tokens', error);
          oktaAuth.tokenManager.clear();
          // Don't need to redirect - authState change will trigger it
          return;
        } finally {
          setIsValidating(false);
        }
      }

      // If not authenticated, redirect to login
      if (authState && !authState?.isAuthenticated) {
        const originalUri = toRelativeUrl(
          globalThis.location.href,
          globalThis.location.origin
        );
        oktaAuth.setOriginalUri(originalUri);
        oktaAuth.signInWithRedirect();
      }
    };

    validateSession();
  }, [oktaAuth, authState]);

  if (!authState || !authState?.isAuthenticated || isValidating) {
    return <TdsLoadingSpinner centered label="Authenticating..." />;
  }

  return <Outlet />;
};
